// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2UkoK","question":"styles_question__3IHg6","description":"styles_description__1PZJS"};